import { 
  MapPin, 
  Star, 
  ArrowBigUpDash, 
  MonitorStop, 
  Clock, 
  Quote, 
  Network 
} from 'lucide-react'
import { useState } from 'react'
import { FilterPanel, type Filters as TimelineLikeFilters } from '@/components/FilterPanel'
import { SidebarActions } from '@/components/SidebarActions'
import { useCuration } from '@/contexts/curation'
import { CurationFilters } from '@/utils/curation'

export function CurationSidebar() {
  const { filters, setFilters } = useCuration()
  const [isFiltersPanelOpen, setIsFiltersPanelOpen] = useState(false)
  
  const sidebarItems = [
    { icon: MapPin, label: 'Território' },
    { icon: Star, label: 'Favoritos' },
    { icon: ArrowBigUpDash, label: 'Upload' },
    { icon: MonitorStop, label: 'Monitor' },
    { icon: Clock, label: 'Histórico' },
    { icon: Quote, label: 'Citações' },
    { icon: Network, label: 'Hierarquia' }
  ]

  const onFiltersApply = (newFilters: TimelineLikeFilters) => {
    const curationFilters: CurationFilters = {
      search: filters.search,
      period: filters.period,
      territories: newFilters.territories || undefined,
      contexts: newFilters.contexts || undefined,
      topics: newFilters.topics || undefined,
      partners: newFilters.partners || undefined,
      sources: newFilters.sources || undefined,
      favorited: newFilters.favorited,
      created_by: newFilters.created_by,
    }
    setFilters(curationFilters)
  }

  return (
    <div className="flex self-start sticky top-20">
      <FilterPanel
        isOpen={isFiltersPanelOpen}
        onClose={() => setIsFiltersPanelOpen(false)}
        onApply={onFiltersApply}
      />
      <SidebarActions
        onToggleFilters={() => setIsFiltersPanelOpen(!isFiltersPanelOpen)}
        items={sidebarItems}
      />
    </div>
  )
}
